// extracted by css-extract-rspack-plugin
export default {"wrapper":"rpUbFscV","inner":"Q2wsaN_0","tab":"xmY1VgmV","tabActive":"IHStJDUO"};